import { useNavigate } from "react-router-dom";
import { trackSchedule } from "@/shared/utils/metaPixel";
import { SEO } from "@/shared/components/SEO";

export default function AdLandingPage2() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/auth?mode=signup&trial=true", { state: { from: "/lp/pricing" } });
  };

  const handleBack = () => {
    navigate("/lp/see-the-job");
  };

  const handleBookDemo = () => {
    trackSchedule({ email: "" }, "Demo Request");
    window.open("https://link.strategicleadd.com/widget/booking/2l5we3GFpAygSb6ATQuW", "_blank");
  };

  return (
    <>
      <SEO title="Simple Pricing — wlkthru" description="One plan. No surprises. Built for all teams." />
      <div style={{ fontFamily: "'Montserrat', sans-serif", color: "#020817", lineHeight: 1.6 }}>
        {/* Nav */}
        <nav style={{ padding: "20px 24px", background: "white", borderBottom: "1px solid #D9E4EF" }}>
          <div style={{ maxWidth: 1200, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 28, fontWeight: 700, color: "#97AAF7" }}>wlkthru</span>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <button onClick={handleBack} style={{ background: "transparent", color: "#9CA3AF", border: "none", fontWeight: 500, cursor: "pointer", fontSize: 14 }}>
                ← Back
              </button>
              <button onClick={handleGetStarted} style={{ background: "#97AAF7", color: "white", border: "none", borderRadius: 10, padding: "10px 24px", fontWeight: 600, cursor: "pointer", fontSize: 14 }}>
                Start Free Trial
              </button>
            </div>
          </div>
        </nav>

        {/* Hero */}
        <section style={{ padding: "80px 24px", textAlign: "center", background: "linear-gradient(135deg, #F8F8FC 0%, #FFFFFF 100%)" }}>
          <h1 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, fontSize: 48, marginBottom: 16 }}>Simple Pricing</h1>
          <p style={{ fontSize: 18, color: "#647488" }}>One plan. No surprises. Built for all teams.</p>
        </section>

        {/* Pricing card */}
        <section style={{ padding: "60px 24px" }}>
          <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <div style={{ background: "white", border: "2px solid #97AAF7", borderRadius: 16, padding: "48px 48px", textAlign: "center", boxShadow: "0 8px 32px rgba(151,170,247,0.15)" }}>
              <h2 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 24, color: "#647488", marginBottom: 16 }}>wlkthru Pro</h2>
              <div style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 56, fontWeight: 700, marginBottom: 8 }}>
                $99<span style={{ fontSize: 18, color: "#647488", fontWeight: 400 }}>/month</span>
              </div>
              <p style={{ color: "#647488", marginBottom: 24 }}>2 users included</p>
              <ul style={{ listStyle: "none", margin: "32px auto", textAlign: "left", maxWidth: 400 }}>
                {[
                  "Unlimited video calls",
                  "Scheduled calls",
                  "Recorded walkthroughs",
                  "In-call notes & checklists",
                  "Web, iOS & Android",
                  "AI transcript",
                  "Email support",
                ].map((f) => (
                  <li key={f} style={{ padding: "12px 0", borderBottom: "1px solid #F0F0F0" }}>
                    <span style={{ color: "#3DDBA1", fontWeight: "bold", marginRight: 12 }}>✓</span>{f}
                  </li>
                ))}
              </ul>
              <button onClick={handleGetStarted} style={{ background: "#97AAF7", color: "white", border: "none", borderRadius: 12, padding: "16px 48px", fontWeight: 600, cursor: "pointer", fontSize: 16 }}>
                Start 15-Day Free Trial
              </button>
            </div>

            {/* Add-on */}
            <div style={{ background: "#F8F8FC", padding: 32, borderRadius: 12, marginTop: 32, textAlign: "center" }}>
              <h3 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 20, marginBottom: 12 }}>Invoicing Add-On — $15/month</h3>
              <p style={{ color: "#647488", fontSize: 15 }}>Send invoices right after the call. <strong>Customers pay the card fee, you keep 100%.</strong></p>
            </div>

            {/* Extra users */}
            <div style={{ background: "#F8F8FC", padding: 32, borderRadius: 12, marginTop: 16, textAlign: "center" }}>
              <h3 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 20, marginBottom: 12 }}>Additional Users — $49.99/month each</h3>
              <p style={{ color: "#647488", fontSize: 15 }}>Growing team? Add as many users as you need.</p>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section style={{ padding: "80px 24px", background: "#F8F8FC" }}>
          <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <h2 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, textAlign: "center", fontSize: 36, marginBottom: 48 }}>Frequently Asked Questions</h2>
            {[
              { q: "Can I add more users?", a: "Yes. Additional users are $49.99/month each. Perfect for growing teams." },
              { q: "How does the invoicing add-on work?", a: "When you send an invoice through wlkthru, your customer pays a small card processing fee. You receive 100% of the invoice amount." },
              { q: "What if I want to cancel?", a: "You can cancel anytime. No contracts, no penalties, no hassle." },
            ].map((item) => (
              <div key={item.q} style={{ marginBottom: 32 }}>
                <h3 style={{ fontFamily: "'League Spartan', sans-serif", fontSize: 18, marginBottom: 8 }}>{item.q}</h3>
                <p style={{ color: "#647488" }}>{item.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section style={{ padding: "80px 24px", background: "#97AAF7", textAlign: "center", color: "white" }}>
          <h2 style={{ fontFamily: "'League Spartan', sans-serif", fontWeight: 700, fontSize: 36, marginBottom: 16 }}>Ready to get started?</h2>
          <p style={{ fontSize: 18, opacity: 0.9, marginBottom: 32 }}>Try wlkthru free for 15 days. No credit card required.</p>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <button onClick={handleGetStarted} style={{ background: "white", color: "#97AAF7", border: "none", borderRadius: 12, padding: "16px 40px", fontWeight: 600, cursor: "pointer", fontSize: 16 }}>
              Start Free Trial
            </button>
            <button onClick={handleBookDemo} style={{ background: "transparent", color: "white", border: "2px solid white", borderRadius: 12, padding: "16px 40px", fontWeight: 600, cursor: "pointer", fontSize: 16 }}>
              Book a Demo
            </button>
          </div>
        </section>
      </div>
    </>
  );
}
